import angular from 'angular'
import { LayoutShellComponent } from './layout-shell.component';

export const LayoutModule = angular
    .module("apex.mainApp.layout", [])
    .component("apexLayoutShell", LayoutShellComponent)
    .name
